export default __webpack_public_path__ + "locales/fi/Files.json?hash=e4bcf8831401278c0016dc47391c4214";